export default __webpack_public_path__ + "97fddf2b2b9395c77a4908cf7611b1d4.svg";